import { createImageCdnLink } from "../";

function imagePath(imageId, fileName) {
  return process.env.REACT_APP_PICKEM_IMAGE_CDN ? `${process.env.REACT_APP_PICKEM_IMAGE_CDN}/${imageId}/${fileName}` : `//cdn.low6-prod.com/${imageId}/${fileName}`;
}

function getClubLogo(pickem, isAwayTeam) {
  let logo = "";
  let team;

  if (pickem && pickem.footballMatch) {
    if (isAwayTeam) {
      team = pickem.footballMatch.awayTeam;
    } else {
      team = pickem.footballMatch.homeTeam;
    }

    if (team.media.length > 0) {
      logo = imagePath(team.media[0].id, team.media[0].file_name);
    } else {
      logo = createImageCdnLink(process.env.REACT_APP_CLUB_LOGO_PLACEHOLDER);
    }
  }

  return logo;
}

export default getClubLogo;